// extracted by mini-css-extract-plugin
export default {"preview":"umWS_","img":"c_QzW"};